/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export interface CvTrackInput {
  /** テナントID */
  tenantId: string
  /** MoovyセッションID（localStorage の moovy_viewer_session.sessionId） */
  sessionId: string
  /**
   * GA4のclient_id（_gaクッキーから取得）
   * @nullable
   */
  ga4ClientId?: string | null
}
